/**
 * Taille de page par défaut
 */
export const DEFAULT_PAGE_SIZE = 20;

/**
 * Options de taille de page disponibles
 */
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

/**
 * Direction de tri par défaut
 */
export const DEFAULT_SORT_DIRECTION = 'DESC' as const;

/**
 * Page initiale
 */
export const DEFAULT_PAGE = 1;
